
export function validateDateObject(dateObj) {

	let isInvalid = false;

	if (dateObj === null || dateObj === undefined || typeof dateObj !== 'object')
		isInvalid = 'invalidDateObject';

	else if (dateObj.date && (typeof dateObj.date !== 'string' || !/[0-9]{12}/.test(dateObj.date)))
		isInvalid = 'invalidDateObject';

	else if (typeof dateObj.hasTime !== 'boolean')
		isInvalid = 'invalidDateObject';

	else if (dateObj.epoch && isNaN(dateObj.epoch))
		isInvalid = 'invalidDateObject';

	return isInvalid;

}

// Also false if date1 is same as date2
export function date1IsBeforeDate2(date1, date2) {

	let isInvalid =
		Boolean(date1.epoch) && Boolean(date2.epoch) &&
		date1.epoch > date2.epoch
		&& 'date1IsNotBeforeDate2';

	return isInvalid;
}

export function dateObjectHasTime(dateObj) {
	if (dateObj.hasTime) {
		return false;
	}
	return 'timeNotSet';
}

// This function could be used in newOrder as well
export function validateDatePair(dateFrom, dateTo) {
	let errorFrom = validateDateObject(dateFrom);
	let errorTo = validateDateObject(dateTo);
	if (Boolean(errorFrom) || Boolean(errorTo)) {
		return [errorFrom, errorTo];
	}

	errorFrom = dateObjectHasTime(dateFrom);
	errorTo = dateObjectHasTime(dateTo);
	if (errorFrom || errorTo) {
		return [errorFrom, errorTo];
	}

	errorFrom = errorTo = date1IsBeforeDate2(dateFrom, dateTo);
	return [errorFrom, errorTo];
}

export function driverIsContactable(driver) {
	let hasNumber = Boolean(driver.phoneNumber && driver.phoneNumber.length);
	let hasEmail = Boolean(driver.email && driver.email.length);
	return (hasNumber || hasEmail) ? false : 'driverNotContactable';
}

export function validateTripAddress(address) {
	if (!address || typeof address !== 'object' || !Object.keys(address).length) {
		return 'mandatoryField';
	}
	if (!address.name && !address.postalCode) return 'missingNameAndPostalCode';
	if (!address.name) return 'missingName';
	if (!address.postalCode) return 'missingPostalCode';

	if (address.countryCode && address.countryCode === 'NO' && !/^[0-9]{4}|^$/.test(address.postalCode)) {
		return 'invalidNorwegianPostalCode';
	}
	return false;
}

export function validateVendor(vendor) {
	if (!vendor || typeof vendor !== 'object' || !Object.keys(vendor).length) {
		return 'mandatoryField';
	}
	if (!vendor.name && !vendor.vendorNumber) return 'missingNameAndVendorNumber';
	if (!vendor.name) return 'missingName';
	if (!vendor.vendorNumber) return 'missingVendorNumber';

	return false;
}

export function validateLicencePlate(licencePlate) {
	if (!licencePlate)
		return true;
	if ((licencePlate.indexOf('401') === 0 && licencePlate.length === 20) || licencePlate.length === 17)
		return true;
	return false;
}